import React from "react";
import Footer from "../Footer/Footer";
import NavMenu from "../NavMenu/NavMenu";
import "./Layout.css";

const Layout = ({ children }) => {
  return (
    <div>
      <NavMenu />
      <main className="container">
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
